import React from 'react';
import { useTranslation } from 'react-i18next';
import css from './AccessDenied.scss';

export default () => {
    const { t } = useTranslation();
    return (
        <div className={css.forbiddenContainer}>
            <h1>{t('common:errorMessages:accessDenied')}</h1>
            <p>{t('common:errorMessages:noPermissionToAccessThisContent')}</p>
        </div>
    );
};
